/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React from 'react';
import { TweetyWidget } from '@vlinder-web/tweety-widget-react';
import { useTheme } from '@/providers/theme';
import { EmailKYC, IEmailKYCProps } from './component';

export interface IKYCProps {
  kycFormFields?: any;
  kycFormLayout?: any;
  kycFormInitialData?: any;
  kycFormValidator?: any;
  emailKYCFields?: any;
  emailKYCLayout?: any;
  email?: string;
  onKYCSubmit?(data: any): void;
  renderSubmitButton?(): void;
  isEmailVerified?: boolean;
}

export type IKYCFormProps = IKYCProps & IEmailKYCProps;

export const KYCForm = (props: IKYCFormProps) => {
  const {
    emailKYCFields,
    emailKYCLayout,
    kycFormFields,
    kycFormLayout,
    kycFormInitialData,
    kycFormValidator,
    email,
    onKYCSubmit,
    renderSubmitButton,
    isEmailVerified,
    onEmailSubmit,
    onOTPSubmit,
    resendOtpClick,
    emailSent,
  } = props;
  const theme = useTheme();
  const _getBodyContent = () => {
    if (!isEmailVerified) {
      return (
        <EmailKYC
          emailKYCFields={emailKYCFields}
          emailKYCLayout={emailKYCLayout}
          onEmailSubmit={onEmailSubmit}
          onOTPSubmit={onOTPSubmit}
          resendOtpClick={resendOtpClick}
          emailSent={emailSent}
          email={email}
          renderSubmitButton={renderSubmitButton}
        />
      );
    } else {
      return (
        <TweetyWidget
          labelColor={theme.colors.orangePrimary}
          fields={kycFormFields}
          layout={kycFormLayout}
          validatorConfig={kycFormValidator}
          initialData={kycFormInitialData}
          onFormSubmit={onKYCSubmit}
          renderSubmitButton={renderSubmitButton}
        />
      );
    }
  };
  return <>{_getBodyContent()}</>;
};
